import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

export const fetchPaymentHistory = createAsyncThunk(
  "payment/paymentHistoryThunk",
  async (args = {}, { }) => {
      const query = generateQueryParams(args);
      const response = await api.get(`/payment/overview/payment-history?${query}`);
      return response.data;
  }
);

export const downloadPaymentHistory = createAsyncThunk(
  "payment/download/payment-history",
  async () => {
      const response = await api.get(`/payment/download/payment-history`, {
          responseType: 'blob' // Important: tells axios to treat response as binary data
      });
      
      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'text/csv' });
      
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = `payment-history-${new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5)}.csv`; // filename with date and time
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return { 
        message: 'Payment history downloaded successfully',
      };
  }
);
